import script from "./FilingsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilingsInfo.vue?vue&type=script&setup=true&lang=ts"

import "./FilingsInfo.vue?vue&type=style&index=0&id=b8400010&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8400010"]])

export default __exports__